import { mergeDeepRight } from "ramda";

function updateState(componentReference, newState) {
  componentReference.setState(
    mergeDeepRight(componentReference.state, newState)
  );
}

export default updateState;



// WEBPACK FOOTER //
// ./src/common/updateState.js